import { render, staticRenderFns } from "./PharmacyView.vue?vue&type=template&id=d4960dd0"
import script from "./PharmacyView.vue?vue&type=script&lang=js"
export * from "./PharmacyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports